import Formulario from "../../components/Formulario/Formulario";
import Job from "../../assets/images/mesa.png";
import Job1 from "../../assets/images/jobs.png";
import Job2 from '../../assets/images/job2.png';

import './Curriculo.css';
import SeparatorBar from "../../components/SeparatorBar/SeparatorBar";

const Curriculo = () => {
  return (
    <>
      <div className="jobs">
        <img src={Job1} alt="" />
      </div>
      <div className="separator-jobs">
        <SeparatorBar />
        <div className="container">
          <div className="title-jobs">
            <h2> <img src={Job2} alt="" />Currículo online</h2>
          </div>
        </div>
      </div>
      <Formulario />
    </>
  )
}
export default Curriculo;